import { isTernaryOperator } from "@skilitics/judy";
import { isValueTombstone } from "@skilitics/nautilus-core-designer-data";

import { operatorToEnglish } from "../../../effects-conditions/condition-builders/helpers.ts";
import { ConditionBuilderSummary } from "../../../effects-conditions/condition-builders/ui/Summary.tsx";
import type { ConditionViewComponentProps } from "../../../types/index.ts";
import { useDescribeValueOperand } from "../../../values/forms/useDescribeValueOperand.ts";
import { useValueConfigSummary } from "../../../values/forms/useValueConfigSummary.ts";
import { useValueSignature } from "../../../values/useValueSignature.ts";
import type { ValueExpressionConditionContext } from "./valueExpressionConditionBuilder.tsx";

export const ValueExpressionConditionSummary = ({
  spec: { title },
  config: { subject, operator, value, value2 },
}: ConditionViewComponentProps<ValueExpressionConditionContext>) => {
  const summarise = useValueConfigSummary();
  const describeOperand = useDescribeValueOperand();
  const signature = useValueSignature(subject);

  // a tombstoned subject names a value that has gone: there is nothing to show
  const subjectTitle = subject && !isValueTombstone(subject) ? summarise(subject) : undefined;
  // the buildable's own title until a subject is picked — an expression over nothing has no reading
  if (subjectTitle === undefined) return <ConditionBuilderSummary title={title} />;
  if (!operator) return <ConditionBuilderSummary title={String(subjectTitle)} />;

  const describe = (operand: unknown) => describeOperand(operand, signature);

  return (
    <ConditionBuilderSummary
      title={String(subjectTitle)}
      operator={operatorToEnglish(operator as Parameters<typeof operatorToEnglish>[0])}
      value={isTernaryOperator(operator) ? `${describe(value)} and ${describe(value2)}` : describe(value)}
    />
  );
};
